<div *ngIf="canShow" class="display-flex hdw-paginator hdw-paginator-alignment">
  <button
    *ngIf="canShowJumpToStart()"
    class="jump-to-start usa-button--unstyled hdw-paginator-item"
    aria-label="Jump to Start"
    (click)="handleJumpToStart()"
  >
    <i class="fa fa-backward-step font-size-rem-1-point25"></i>
  </button>
  <button
    *ngIf="selectedIndex > 0"
    class="back-button usa-button--unstyled hdw-paginator-item"
    aria-label="Back"
    (click)="handleBack()"
  >
    <i class="fa-solid fa-chevron-left font-size-rem-1-point25"></i>
  </button>
  <ng-container *ngFor="let pageItem of pagesToRender">
    <button
      class="page-button usa-button--unstyled font-family-public-sans-normal text-no-underline hdw-paginator-item"
      [attr.aria-label]="'Page ' + pageItem"
      (click)="handlePageClick(pageItem)"
      [ngClass]="{ 'page-selected': pageItem - 1 === selectedIndex }"
    >
      {{ pageItem }}
    </button>
  </ng-container>
  <button
    *ngIf="selectedIndex < totalPages - 1"
    class="next-button usa-button--unstyled hdw-paginator-item"
    aria-label="Next"
    (click)="handleNext()"
  >
    <i class="fa-solid fa-chevron-right font-size-rem-1-point25"></i>
  </button>
  <button
    *ngIf="canShowJumpToEnd()"
    class="jump-to-end usa-button--unstyled hdw-paginator-item-last"
    aria-label="Jump to End"
    (click)="handleJumpToEnd()"
  >
    <i class="fa fa-forward-step font-size-rem-1-point25"></i>
  </button>
</div>
